import type { ListResponseOverrideReason, ListResponseOverrideReasonData } from "@classes-service-types/index.ts";
import { type UseQueryOptions, useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { computed, type Ref, unref } from "vue";
import { learningServiceRequest } from "@/services/utils";

interface Args<TData = ListResponseOverrideReasonData> {
  limit?: Ref<number> | number;
  skip?: Ref<number> | number;
  q?: Ref<string>;
  getArchived?: Ref<boolean> | boolean;
  useQueryOptions?: Partial<UseQueryOptions<ListResponseOverrideReasonData, Error, TData>>;
}

export const useGetOverrideReasons = <TData = ListResponseOverrideReasonData>({
  limit,
  skip,
  getArchived,
  q,
  useQueryOptions,
}: Args<TData>) => {
  const fetchPriceOverrideReasons = async (): Promise<ListResponseOverrideReasonData> => {
    return learningServiceRequest({
      method: "get",
      url: "/override_reasons/",
      params: {
        limit: unref(limit) || 1000,
        skip: unref(skip) || 0,
        get_archived: unref(getArchived),
        q: unref(q),
      },
    }).then((response: AxiosResponse<ListResponseOverrideReason>) => response.data.data);
  };

  return useQuery<ListResponseOverrideReasonData, Error, TData>({
    queryKey: computed(() => ["getOverrideReasons", limit, skip, getArchived, q]),
    queryFn: fetchPriceOverrideReasons,
    ...useQueryOptions,
  });
};
